import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getRequestRelatedRequestsRecipients } from '../../../../api'
import { SIZE } from '../../../../constants/size'
import { useNotification } from '../../../../hooks'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  toEmailRecipientSelectItems,
} from '../../../Email'
import { FormModal } from '../../../Form'
import { toAttachedRequestRecipientSelectItem } from '../RequestProfileTabEmailsCreateEmailPopUp'

import { FormFields } from './FormFields'
import {
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME,
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME,
} from './RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal.constants'
import { getInitialValues } from './RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal.utils'

function RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal({
  requestId,
  onClose,
}) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { setFieldValue } = useFormikContext()

  function handleSubmit({ values }) {
    const recipientType =
      values[ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME]
        .value
    const excludeArchived =
      values[ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME]

    getRequestRelatedRequestsRecipients(requestId, {
      exclude_archived_requests: excludeArchived,
      recipient_type: recipientType,
    })
      .then(({ data }) => {
        handleAddSuccessNotification('Notification.CommonTitleAppliedKey')
        setFieldValue(
          EMAIL_CREATION_FORM_FIELD_NAME_TO,
          toEmailRecipientSelectItems(
            data.items,
            toAttachedRequestRecipientSelectItem
          )
        )
      })
      .finally(() => {
        onClose()
      })
  }

  return (
    <FormModal
      Fields={FormFields}
      formBodyProps={{
        contentProps: {
          size: SIZE.X_LARGE,
        },
        submitButtonText: 'Modal.ApplyBtnKey',
        withNotifications: true,
      }}
      formTitle='RequestProfile.AttachedRequestsRecipientsFilterTitleKey'
      initialValues={getInitialValues(t)}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal
